import { render, staticRenderFns } from "./apiCheckSCM8.vue?vue&type=template&id=a852b156&scoped=true&"
import script from "./apiCheckSCM8.vue?vue&type=script&lang=js&"
export * from "./apiCheckSCM8.vue?vue&type=script&lang=js&"
import style0 from "./apiCheckSCM8.vue?vue&type=style&index=0&id=a852b156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a852b156",
  null
  
)

export default component.exports